<template>
  <div>
    <v-dialog
      v-model="inValid"
      scrollable
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-title>Missing Requirements</v-title>
        <v-layout row wrap>
          <v-flex xs12>
            <v-subheader>
              Your order does not have all the required information. Follow the
              links below to complete the order correctly.
            </v-subheader>
          </v-flex>
          <v-flex xs12>
            <ul>
              <li v-for="(item, index) in requirements" :key="index">
                {{ item.text }}
                <v-btn small color="primary" :to="item.path[0]">Edit</v-btn>
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" to="create-ipvoice">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { routes } from "@/routes";
import { mapState, mapGetters } from "vuex";

export default {
  name: "QantasRequirements",
  data() {
    return {
      requirements: []
    };
  },
  computed: {
    ...mapState(["orders"]),
    ...mapState("orders", ["summary"]),
    ...mapGetters("orders", ["totalCost", "isGrenke", "isQantas"]),
    inValid() {
      return this.requirements.length > 0;
    }
  },
  methods: {
    validateOrder() {
      return new Promise((resolve, reject) => {
        let vm = this;
        if (
          vm.summary.reportView.hardwareOrder &&
          vm.summary.reportView.hardwareOrder.totalInitialPayment > 0
        )
          if (!vm.summary.reportView.hardwareOrder.contactName)
            vm.requirements.push({
              text: "Please confirm hardware delivery information",
              path: ["/create-hardware/true"]
            });

        if (!vm.isGrenke) {
          //only for non qbr orders
          //direct debit check
          if (
            !vm.summary.reportView.directDebit ||
            vm.summary.reportView.directDebit == "No"
          ) {
            vm.requirements.push({
              text: "Direct Debit information missing",
              path: ["/direct-debit"]
            });
          }
        } else {
          // let path = routes.filter(x => x.name == "CreateIPVoice").map(y => y.path);
          // if (vm.orders.rows[0].ipOrderID === 0)
          //   vm.requirements.push({
          //     text: "Needs IP Voice order",
          //     path: path
          //   });

          let path = routes
            .filter(x => x.name == "DirectDebit")
            .map(y => y.path);
          if (!vm.summary.reportView.directDebit.accountName)
            vm.requirements.push({
              text: "Direct Debit information missing",
              path: path
            });
          path = routes.filter(x => x.name == "CreateCompany").map(y => y.path);
          if (!vm.orders.rows[0].customerDetails.companyDetails.companyName)
            vm.requirements.push({
              text: "Must have a company name filled out.",
              path: path
            });

          if (vm.isGrenke && vm.totalCost > 0) {
            path = routes
              .filter(x => x.name == "CreateCustomer")
              .map(y => y.path);
            if (
              !vm.orders.rows[0].contacts.some(x => x.position === "Director")
            )
              vm.requirements.push({
                text: "Must have a Director",
                path: path
              });

            if (!vm.orders.rows[0].contacts.some(x => x.isGuarantor))
              vm.requirements.push({
                text: "Must have a Guarantor",
                path: path
              });

            if (!vm.orders.uploads.rows.some(x => x.fileType == "licence")) {
              vm.requirements.push({
                text: "Must upload copy of drivers licence",
                path: ["/attachments/licence"],
                fileType: "licence"
              });
            }
            if (
              !vm.orders.uploads.rows.some(x => x.fileType == "businessCard")
            ) {
              vm.requirements.push({
                text: "Must upload copy of business card",
                path: ["/attachments/businessCard"],
                fileType: "businessCard"
              });
            }

            if (vm.isGrenke && vm.totalCost < 500.0 / 1.1) {
              vm.requirements.push({
                text: "Hardware costs must exceed $500",
                path: ["/create-ipvoice"]
              });
            }
          }
        }
        if (vm.inValid) reject("Not a valid order");
        else resolve("All good");
      });
    }
  }
};
</script>

<style scoped></style>
